import { useEffect } from 'react';
import { ErrorState } from '@/components/common/ErrorState';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpPrintSheet } from '../PcmpPrint/PcmpPrintSheet';
import { PcmpBatchReport, type PcmpBatchReportData } from './PcmpBatchReport';

interface PcmpBatchPrintViewProps {
  batchNo: number;
  report: PcmpBatchReportData | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  refetch: () => void;
  /** The tab title, which browsers also offer as the PDF's file name. */
  documentTitle: string;
}

/** A batch report on landscape A4 sheets, opening the print dialog once loaded. */
export function PcmpBatchPrintView({
  batchNo,
  report,
  isLoading,
  isFetching,
  error,
  refetch,
  documentTitle,
}: PcmpBatchPrintViewProps) {
  useEffect(() => {
    if (report) document.title = documentTitle;
  }, [report, documentTitle]);

  if (isLoading) return <PageLoader />;

  if (error || !report) {
    return (
      <div className="p-6">
        <ErrorState
          error={error}
          fallbackTitle={`Could not load the report of batch #${batchNo}`}
          onRetry={refetch}
          isRetrying={isFetching}
          fill
        />
      </div>
    );
  }

  return (
    <PcmpPrintSheet>
      <PcmpBatchReport report={report} />
    </PcmpPrintSheet>
  );
}
